/** True if rich text has visible text (not only empty tags). */
export const hasRichTextContent = (html) => {
  if (!html || typeof html !== "string") return false;
  const plain = html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
  return plain.length > 0;
};
